<template>
  <!-- Create / Edit -->
  <v-dialog
    v-model="dialog"
    width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-toolbar>
      <v-toolbar-title>{{ $route.meta.nameDrawer }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>

    <v-card>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <!-- ========================================= -->
          <!--             Registration form             -->
          <!-- ========================================= -->
          <v-subheader class="overline pt-4">{{
            $t("registrationForm")
          }}</v-subheader>
          <div class="pa-4 px-6">
            <v-text-field
              :label="$t('routeName')"
              v-model="form.name"
              :rules="nameRules"
              required
              clearable
              outlined
              dense
              autofocus
            ></v-text-field>
          </div>
          <!-- ========================================= -->
          <!--                Regionals                  -->
          <!-- ========================================= -->
          <v-subheader class="overline pt-4"
            >{{ $t("linkRegional") }}
          </v-subheader>
          <div class="pa-4 px-6">
            <v-select
              v-model="form.regionals.select"
              :items="form.regionals.items"
              :rules="selectRules"
              @change="requestAgents(form.regionals.select)"
              item-text="name_regional"
              item-value="id"
              :label="$t('selectRegional')"
              outlined
              :disabled="edit"
            ></v-select>
          </div>
          <!-- ========================================= -->
          <!--                Agents                     -->
          <!-- ========================================= -->
          <v-subheader class="overline pt-4"
            >{{ $t("linkAgents") }}
          </v-subheader>
          <div class="pa-4 px-6">
            <v-select
              v-model="form.agents.select"
              :items="form.agents.items"
              :rules="selectRules"
              item-text="nome"
              item-value="id"
              :label="$t('selectAgents')"
              outlined
              multiple
              chips
              :disabled="form.regionals.select == ''"
            ></v-select>
          </div>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-alert
        class="ma-4"
        type="warning"
        v-for="item in handleError.items"
        :key="item"
        close-icon
      >
        {{ item }}
      </v-alert>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :loading="loading"
          v-on:click.prevent="updateRoute"
          type="submit"
          :disabled="!valid"
        >
          {{ $t("toSave") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { validate } from "@/util/validate";
export default {
  name: "administrator-route-update",
  data: () => ({
    // Utils
    valid: false,
    loading: false,
    // Form data:
    form: {
      name: "",
      regionals: {
        select: "",
        items: [],
      },
      agents: {
        select: [],
        items: [],
      },
    },
    // Validate Forms:
    nameRules: [validate.required, validate.max],
    requiredRules: [validate.required],
    selectRules: [validate.selectRequired],
    // Handle Error:
    handleError: {
      items: [],
    },
    // Edit
    edit: false,
    id_user: "",
  }),
  async mounted() {
    // =================================================== //
    // SET - Select Regionals
    // =================================================== //
    let requestUsersRegionals = this.$request.post(
      "/administrator/regionals/list",
      { status: 1 }
    );

    const usersRegionals = await requestUsersRegionals;
    this.form.regionals.items = usersRegionals.dados;

    // =================================================== //
    // IF - Edit
    // =================================================== //

    if (!this.$route.params.id) {
      return;
    }

    this.edit = true;
    this.id_user = this.$route.params.id;
    let routeData = await this.$request.post("/administrator/routes/getRoute", {
      id_user: this.id_user,
    });

    // [ Edit ] - Set inputs form
    const { agentsAttachRoute } = routeData;
    const { nome, id_regional } = routeData.dados;
    this.form.name = nome;
    this.form.regionals.select = id_regional;
    this.form.agents.select = agentsAttachRoute;
    await this.requestAgents(id_regional);
    agentsAttachRoute.forEach((element) => {
      this.form.agents.items.push(element);
    });
  },
  computed: {
    dialog() {
      return this.$store.state.showDialog;
    },
  },
  watch: {
    dialog(val) {
      !val && this.$router.go(-1);
    },
  },
  methods: {
    async requestAgents(id_regional) {
      // Reset fields
      this.form.agents.items = [];
      this.edit ? null : (this.form.agents.select = []);
      // =================================================== //
      // SET - Select Agents
      // =================================================== //
      let agentsAvailable = this.$request.post(
        "/administrator/routes/agentsAvailable",
        { id_user: id_regional }
      );

      // Request's Simultaneously
      let agents = await agentsAvailable;
      if (agents.dados == undefined) {
        this.form.agents.items = agents;
      } else {
        agents.dados.forEach((element) => {
          this.form.agents.items.push(element);
        });
      }
    },
    //
    // updateRoute: Create or Edit Agent.
    async updateRoute() {
      if (!this.$refs.form.validate()) {
        return;
      }

      // Progress
      this.$store.commit("setFeedbackProgress", true);
      this.loading = true;

      // Body Form
      const formUpdateRoute = {
        nome: this.form.name,
        id_regional: this.form.regionals.select,
      };

      // Handler routes to formUpdateRoute
      const selected = this.form.agents.select;
      const agentes = {};
      for (let i = 0; i < selected.length; i++) {
        agentes[`agentes[${i}]`] =
          selected[i].id == undefined ? selected[i] : selected[i].id;
      }

      Object.assign(formUpdateRoute, agentes);

      try {
        if (this.edit) {
          Object.assign(formUpdateRoute, { id_rota: this.id_user });
        }

        // Handle Endpoint
        const updateEndpoint = this.edit
          ? "administrator/routes/editRoute"
          : "administrator/routes/addRoute";

        const result = await this.$request.post(
          updateEndpoint,
          formUpdateRoute
        );
        if (result.length == 0) {
          return;
        }

        this.$store.commit("setFeedbackSnack", {
          msg: result.messages,
          color: "success",
        });

        if (!this.edit) {
          this.$refs.form.reset();
        }

        this.$store.commit("showDialog", false);
        this.$store.commit("setRefresh", true);
      } catch (error) {
        // Multiple error handler:
        if (error.response.status == 406) {
          const items = [];
          var obj = error.response.data.messages;
          for (var [key, value] of Object.entries(obj)) {
            const item = `${key}: ${value}`;
            items.push(item);
          }
          this.handleError.items = items;
        }
      } finally {
        this.loading = false;
      }
    },

    // Close Dialog
    closeDialog() {
      this.$store.commit("showDialog", false);
    },
  },
};
</script>
